import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading, text" theme="lightest" className="titleBlock-align-left" id="customer" mdxType="TitleBlock" />
    <h3 {...{
      "id": "customer-stories"
    }}>{`Customer stories`}</h3>
    <p>{`See how our customers are building great experiences and succeeding with Adobe.`}</p>
    {/* <ResourceCard slots="link, image, heading,text" width="25%" theme="lightest"  className='useCaseCard card-heading-size' isCustomStories/>
     [mtec-story.pdf](../resources/mtec-story.pdf)
     ![EMPTY_ALT](../images/mtec.png)
     ### MTEC
     MTEC uses Adobe PDF Extract API to improve speed and accuracy of automatic text extraction from financial data PDF files. */}
    <ResourceCard slots="link, image, heading, text " width="33%" theme="lightest" className='useCaseCard card-heading-size' isCustomStories mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/assets/56acbb27cf0bc151d0aaa151c610efd6/AdobeExpCloudStory.pdf"
      }}>{`AdobeExpCloudStory.pdf`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "811px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "58.12500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/55d4aaef416e8ed0e5bca01bdd41c31d/5530d/AE_story.webp 320w", "/document-services/static/55d4aaef416e8ed0e5bca01bdd41c31d/0c8fb/AE_story.webp 640w", "/document-services/static/55d4aaef416e8ed0e5bca01bdd41c31d/80d25/AE_story.webp 811w"],
            "sizes": "(max-width: 811px) 100vw, 811px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/55d4aaef416e8ed0e5bca01bdd41c31d/dd4a7/AE_story.png 320w", "/document-services/static/55d4aaef416e8ed0e5bca01bdd41c31d/0f09e/AE_story.png 640w", "/document-services/static/55d4aaef416e8ed0e5bca01bdd41c31d/55bfd/AE_story.png 811w"],
            "sizes": "(max-width: 811px) 100vw, 811px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/55d4aaef416e8ed0e5bca01bdd41c31d/55bfd/AE_story.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "adobe"
    }}>{`Adobe`}</h3>
    <p>{`Agreement Experience is projected to save deal desk and sales attorneys 36,000 hours annually on contracts.`}</p>
    <ResourceCard slots="link, image, heading,text" width="33%" theme="lightest" className='useCaseCard card-heading-size hme-custom-header' isCustomStories mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/assets/2caabedcceb0a9d8b1c30764bd0f82ad/aftia-story.pdf"
      }}>{`aftia-story.pdf`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "815px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "52.5%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/d96be00b46aedc9a15878647afe93535/5530d/aftia.webp 320w", "/document-services/static/d96be00b46aedc9a15878647afe93535/0c8fb/aftia.webp 640w", "/document-services/static/d96be00b46aedc9a15878647afe93535/58a39/aftia.webp 815w"],
            "sizes": "(max-width: 815px) 100vw, 815px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/d96be00b46aedc9a15878647afe93535/dd4a7/aftia.png 320w", "/document-services/static/d96be00b46aedc9a15878647afe93535/0f09e/aftia.png 640w", "/document-services/static/d96be00b46aedc9a15878647afe93535/7190f/aftia.png 815w"],
            "sizes": "(max-width: 815px) 100vw, 815px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/d96be00b46aedc9a15878647afe93535/7190f/aftia.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "aftia"
    }}>{`AFTIA`}</h3>
    <p>{`AFTIA helps a multinational financial services company better serve clients by accelerating client onboarding with Adobe apps and APIs.`}</p>
    <ResourceCard slots="link, image, heading,text" width="33%" theme="lightest" className='useCaseCard card-heading-size' isCustomStories mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "/document-services/assets/7aa1943467e10f0ba14285d0fbde1a8f/AI-Singapore-Story.pdf"
      }}>{`AI-Singapore-Story`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "53.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/327145ac6683134e93e1066f55de467f/5530d/AISingapore.webp 320w", "/document-services/static/327145ac6683134e93e1066f55de467f/0c8fb/AISingapore.webp 640w", "/document-services/static/327145ac6683134e93e1066f55de467f/94b1e/AISingapore.webp 1280w", "/document-services/static/327145ac6683134e93e1066f55de467f/35ff6/AISingapore.webp 1356w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/327145ac6683134e93e1066f55de467f/dd4a7/AISingapore.png 320w", "/document-services/static/327145ac6683134e93e1066f55de467f/0f09e/AISingapore.png 640w", "/document-services/static/327145ac6683134e93e1066f55de467f/bbbf7/AISingapore.png 1280w", "/document-services/static/327145ac6683134e93e1066f55de467f/2637b/AISingapore.png 1356w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/327145ac6683134e93e1066f55de467f/bbbf7/AISingapore.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "ai-singapore-aisg"
    }}>{`AI Singapore (AISG)`}</h3>
    <p>{`AI Singapore accelerates deep learning models with Adobe PDF Extract API.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      